import React from "react";
import { Link } from "react-router-dom";

import { usePosts } from "../custom-hooks";
import { readableDate } from "../helper";
import "./Posts.scss";

export default function Posts() {
  const [posts, isLoading] = usePosts();

  const renderPosts = () => {
    if (isLoading) return <p>Loading...</p>;

    return posts.map(post => (
      <Link className="item" key={post.fields.slug} to={post.fields.slug}>
        <div>
          <img
            className="image"
            src={post.fields.link}
            alt={post.fields.title}
          />
        </div>
        <div className='article'>
          <small>{readableDate(post.fields.date)}</small>
          <h2>{post.fields.title}</h2>
          <p>{post.fields.description}</p>
        </div>
      </Link>
    ));
  };

  return (
    <div className="posts-container">
      <div>{renderPosts()}</div>
    </div>
  );
}
